import * as yup from "yup";

export const schema = (t: (val: string) => string) => {
    const validation = {
        school: yup.string().required(t("cmn:val.required")),
        noOfSeats: yup
            .number()
            .typeError(t("cmn:val.required"))
            .required(t("cmn:val.required")),
    };

    return yup.object().shape({ ...validation });
};
